import {
  Button,
  FormControlLabel,
  FormGroup,
  Stack,
  Typography,
  Checkbox,
  Link,
} from "@mui/material";
import { useTranslation, Trans } from "react-i18next";
import FaceIconBrandLarge from "@/theme/icons/FaceIconBrandLarge";
import FullScreenIframeDialog from "@/features/Common/components/FullScreenIframeDialog";
import { useState } from "react";
import DialogWithTrigger from "@/features/Common/components/DialogWithTrigger";
import { LatestContractResponse } from "@/services/core-api-adapter";

interface AcceptTermsAndConditionsProps {
  onAccept: Function;
  latestContractData: LatestContractResponse;
  isSubmitting: boolean;
}

export default function AcceptTermsAndConditions(
  props: AcceptTermsAndConditionsProps
) {
  const { t } = useTranslation();
  const { isSubmitting, onAccept } = props;
  const { description, fileUri } = props.latestContractData;
  const termsAndConditionsFileUri = `${import.meta.env.VITE_APP_CLOUDFRONT_URL}/${fileUri}`;

  const [isTermsAndConditionsAccepted, setIsTermsAndConditionsAccepted] =
    useState(false);

  const [isTermsAndConditionsDialogOpen, setIsTermsAndConditionsDialogOpen] =
    useState(false);

  function toggleTermsAndConditionsDialog(event: React.BaseSyntheticEvent) {
    event?.preventDefault();
    setIsTermsAndConditionsDialogOpen(!isTermsAndConditionsDialogOpen);
  }

  function handleTermsAndConditionsChange(
    event: React.ChangeEvent<HTMLInputElement>
  ) {
    setIsTermsAndConditionsAccepted(event.target.checked);
  }

  return (
    <>
      <Stack p={2} spacing={4} justifyContent="flex-end" sx={{ flex: 1 }}>
        <FaceIconBrandLarge />

        <Typography variant="h3">
          {t("CollectTermsAcceptance.title")}
        </Typography>

        <Stack spacing={1}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  inputProps={{
                    "aria-label": t(
                      "CollectTermsAcceptance.termsAndConditions.checkBox.label"
                    ),
                  }}
                  onChange={handleTermsAndConditionsChange}
                />
              }
              label={
                <Trans i18nKey="CollectTermsAcceptance.termsAndConditions.title">
                  <Link onClick={toggleTermsAndConditionsDialog} />
                </Trans>
              }
            />
          </FormGroup>
        </Stack>

        <DialogWithTrigger
          title={t(
            "CollectTermsAcceptance.termsAndConditions.moreInfoModal.title"
          )}
          description={t(
            "CollectTermsAcceptance.termsAndConditions.moreInfoModal.body"
          )}
        />

        <Stack direction="row" spacing={1}>
          <Button
            fullWidth
            disabled={!isTermsAndConditionsAccepted}
            loading={isSubmitting}
            onClick={() => onAccept(isTermsAndConditionsAccepted)}
          >
            {t("common.continueButton")}
          </Button>
        </Stack>
      </Stack>

      <FullScreenIframeDialog
        title={description}
        isOpen={isTermsAndConditionsDialogOpen}
        onClose={toggleTermsAndConditionsDialog}
        url={termsAndConditionsFileUri}
      />
    </>
  );
}
